import { Matrix4, Vector3,Quaternion } from "three";


const matrix = new Matrix4();

const rotation = new Quaternion();
const scale = new Vector3();

export default function positionFromMatrix(array)
{
    matrix.fromArray(array);
    const translation = new Vector3();
    matrix.decompose(translation, rotation, scale)
    return translation
}
